<template>
  <div class="promo">

    <!-- Hero -->
    <section class="promo__hero">
      <!-- Animated blobs -->
      <div class="promo__blob promo__blob--1"></div>
      <div class="promo__blob promo__blob--2"></div>
      <div class="promo__blob promo__blob--3"></div>

      <div class="promo__hero-inner">
        <div class="promo__hero-panel">
          <!-- Badge -->
          <div class="promo__hero-badge">
            <svg viewBox="0 0 20 20" fill="currentColor"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
            {{ $t('blog.promo100k.badge') }}
            <svg viewBox="0 0 20 20" fill="currentColor"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
          </div>

          <!-- Title -->
          <h1 class="promo__hero-title">{{ $t('blog.promo100k.heroTitle') }}</h1>

          <!-- Lead -->
          <div class="promo__hero-lead">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
            <p v-html="$t('blog.promo100k.heroLead')"></p>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
          </div>

          <!-- Pills -->
          <div class="promo__pills">
            <div class="promo__pill promo__pill--green">
              <svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/></svg>
              {{ $t('blog.promo100k.pillFreeJoin') }}
            </div>
            <div class="promo__pill promo__pill--blue">
              <svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clip-rule="evenodd"/></svg>
              {{ $t('blog.promo100k.pillInstantReward') }}
            </div>
            <div class="promo__pill promo__pill--purple">
              <svg viewBox="0 0 20 20" fill="currentColor"><path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z"/></svg>
              {{ $t('blog.promo100k.pillAttractiveOffer') }}
            </div>
          </div>
        </div>
      </div>

      <!-- Wave -->
      <div class="promo__hero-wave">
        <svg viewBox="0 0 1440 80" fill="none" preserveAspectRatio="none">
          <path d="M0 80L60 65C120 50 240 20 360 10C480 0 600 0 720 7.5C840 15 960 30 1080 37.5C1200 45 1320 45 1380 45L1440 45V80H0Z" fill="#f2f0ea"/>
        </svg>
      </div>
    </section>

    <!-- Content -->
    <main class="promo__main">
      <div class="promo__shell">

        <!-- Article -->
        <article class="promo__article">
          <div class="promo__article-header">
            <h2 class="promo__article-title">
              <span v-html="$t('blog.promo100k.content')"></span>
              <span class="promo__pop-badge">{{ $t('blog.promo100k.badge') }}</span>
            </h2>
          </div>

          <!-- Benefits -->
          <ul class="promo__benefits">
            <li class="promo__benefit">
              <div class="promo__benefit-icon">
                <svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/></svg>
              </div>
              <div>
                <p class="promo__benefit-title">{{ $t('blog.promo100k.benefit1') }}</p>
                <p class="promo__benefit-desc">{{ $t('blog.promo100k.benefit1Desc') }}</p>
              </div>
            </li>
            <li class="promo__benefit">
              <div class="promo__benefit-icon">
                <svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/></svg>
              </div>
              <div>
                <p class="promo__benefit-title">{{ $t('blog.promo100k.benefit2') }}</p>
                <p class="promo__benefit-desc">{{ $t('blog.promo100k.benefit2Desc') }}</p>
              </div>
            </li>
            <li class="promo__benefit">
              <div class="promo__benefit-icon">
                <svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/></svg>
              </div>
              <div>
                <p class="promo__benefit-title">{{ $t('blog.promo100k.benefit3') }}</p>
                <p class="promo__benefit-desc">{{ $t('blog.promo100k.benefit3Desc') }}</p>
              </div>
            </li>
          </ul>

          <!-- Event period -->
          <div class="promo__event-period">
            <strong>{{ $t('blog.promo100k.eventLabel') }}</strong>
            <span>{{ $t('blog.promo100k.eventPeriod') }}</span>
          </div>

          <!-- Gallery image -->
          <div class="promo__gallery" v-if="images && images[0]">
            <div class="promo__gallery-item" @click="openImageModal(images[0])">
              <img
                v-if="images[0].src"
                :src="images[0].src"
                :alt="$t('blog.promo100k.heroTitle')"
                class="promo__gallery-img"
              />
            </div>
          </div>
        </article>

        <!-- Contact -->
        <div class="promo__contact">
          <h2 class="promo__contact-title" @click="goToContact">{{ $t('common.contactNow') }}</h2>
          <div class="promo__contact-grid">
            <a href="https://t.me/songhancapital" target="_blank" rel="noopener noreferrer" class="promo__contact-btn promo__contact-btn--tg">
              <i class="fab fa-telegram-plane"></i>
              <div>
                <strong>{{ $t('common.telegram') }}</strong>
                <span>@SHC Rim</span>
              </div>
            </a>
            <a href="tel:+84766726416" class="promo__contact-btn promo__contact-btn--phone">
              <i class="fas fa-phone"></i>
              <div>
                <strong>{{ $t('common.tel') }}</strong>
                <span>+84.766.726.416</span>
              </div>
            </a>
          </div>
        </div>

        <!-- Product promo -->
        <div class="promo__product">
          <div class="promo__product-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
            </svg>
          </div>
          <div class="promo__product-body">
            <h3>{{ $t('blog.blog1.product') }} ✨</h3>
            <p>{{ $t('blog.blog1.learn') }}</p>
            <div class="promo__product-checks">
              <span><i class="fas fa-check"></i> {{ $t('common.safe') }}</span>
              <span><i class="fas fa-check"></i> {{ $t('common.profit') }}</span>
            </div>
          </div>
          <a href="/blog/dau-tu-an-toan-loi-nhuan-on-dinh-cung-ea-shc" class="promo__product-btn">
            {{ $t('common.findOutNow') }}
            <i class="fas fa-arrow-right"></i>
          </a>
        </div>

      </div>
    </main>

    <!-- Modal -->
    <div v-if="showImageModal" class="promo__modal" @click="closeImageModal">
      <div class="promo__modal-box" @click.stop>
        <button class="promo__modal-close" @click="closeImageModal"><i class="fas fa-times"></i></button>
        <img v-if="selectedImage.src" :src="selectedImage.src" :alt="selectedImage.title || ''" class="promo__modal-img" />
        <div class="promo__modal-caption"><p>{{ selectedImage.caption }}</p></div>
      </div>
    </div>

  </div>
</template>

<script src="./promo-100k.js"></script>
<style src="./promo-100k.scss" lang="scss"></style>
